"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.dispatchToProps = exports.stateToProps = void 0;
var redux_1 = require("redux");
var businessSelectors = __importStar(require("@src/reduxStores/business/selectors"));
var businessActions = __importStar(require("@src/reduxStores/business/actions"));
var store_1 = __importDefault(require("@src/store"));
exports.stateToProps = function (state) {
    return {
        businessId: businessSelectors.getBusinessId(state),
        viaName: businessSelectors.getViaName(state),
        isSelfServe: store_1["default"].getSelfServeLayout(),
    };
};
exports.dispatchToProps = function (dispatch) {
    return redux_1.bindActionCreators({
        setViaName: businessActions.setViaName,
        setPipelineVersion: businessActions.setPipelineVersion,
        setActivePartners: businessActions.setActivePartners,
    }, dispatch);
};
